import { Box } from '@mui/material';
import type { ReactNode } from 'react';

interface BodyProps {
  children: ReactNode;
}

function MainContentWrapper({ children }: BodyProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '100vh' }}>
      {children}
    </Box>
  );
}

export default MainContentWrapper;
